var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    {
      key: _vm.item.id,
      attrs: { xs12: "", md6: "", transition: "slide-x-transition" },
    },
    [
      _c(
        "v-card",
        { staticClass: "product-card", attrs: { hover: "" } },
        [
          _vm.canDelete
            ? _c(
                "v-btn",
                {
                  attrs: {
                    absolute: "",
                    dark: "",
                    fab: "",
                    top: "",
                    right: "",
                    small: "",
                    color: "error",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete", _vm.item.id)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("delete")])],
                1
              )
            : _vm._e(),
          _vm.item.row_state
            ? _c(
                "v-tooltip",
                { attrs: { top: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        absolute: "",
                        dark: "",
                        fab: "",
                        top: "",
                        left: "",
                        color: _vm.activeRowIconStatus.color,
                      },
                    },
                    [
                      _c("v-icon", [
                        _vm._v(_vm._s(_vm.activeRowIconStatus.icon)),
                      ]),
                    ],
                    1
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.item.row_state))]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-flex",
            { attrs: { "d-flex": "", "flex-column": "", "flex-lg-row": "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    "pa-10": "",
                    lg5: "",
                    "d-flex": "",
                    "flex-column": "",
                  },
                },
                [
                  _c("img", {
                    staticClass: "frame-preview",
                    attrs: {
                      src: _vm.item.modello_preview,
                      alt: _vm.item.modello,
                    },
                  }),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs6: "",
                            "mb-3": "",
                            "d-flex": "",
                            "align-center": "",
                          },
                        },
                        [
                          _c("span", { staticClass: "icon icon-montatura" }),
                          _c("img", {
                            attrs: {
                              src: _vm.item.colore_preview,
                              width: "100%",
                              alt: _vm.item.colore,
                            },
                          }),
                        ]
                      ),
                      _vm.item.aste
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs6: "",
                                "mb-3": "",
                                "d-flex": "",
                                "align-center": "",
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "icon icon-coppia-aste",
                              }),
                              _c("img", {
                                staticStyle: {},
                                attrs: {
                                  src: _vm.item.colore_aste_preview,
                                  width: "100%",
                                  alt: _vm.item.colore_aste,
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm.canRestore
                        ? _c(
                            "div",
                            [
                              _vm.canRestore
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "outline-button",
                                      attrs: {
                                        outlined: "",
                                        rounded: "",
                                        large: "",
                                        color: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("restore", _vm.item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.Ripristina"))
                                        ),
                                      ]),
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { "margin-left": "5px" },
                                        },
                                        [_vm._v("replay")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "v-card",
                            {
                              attrs: {
                                elevation: "1",
                                color: "primary",
                                height: "50px",
                              },
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticStyle: { height: "100%" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        color: "white",
                                        height: "100%",
                                      },
                                      attrs: {
                                        "d-flex": "",
                                        "align-center": "",
                                      },
                                    },
                                    [
                                      _vm.user.isUSA
                                        ? _c("div", [
                                            _vm._v(
                                              "Serial Number : " +
                                                _vm._s(_vm.item.id)
                                            ),
                                          ])
                                        : _c(
                                            "div",
                                            { staticClass: "text-center" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("message.Codice")
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t("message.Assistenza")
                                                  ) +
                                                  " : " +
                                                  _vm._s(_vm.item.id) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    "lg-7": "",
                    "d-flex": "",
                    "align-center": "",
                    "overflow-hidden": "",
                  },
                },
                [
                  _c(
                    "v-list",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.Modello")) + ":"
                                  ),
                                ]),
                              ]),
                              _c(
                                "v-flex",
                                { staticClass: "item-description" },
                                [_vm._v(_vm._s(_vm.item.modello))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.Asian_fitting")) +
                                      ":"
                                  ),
                                ]),
                              ]),
                              _c(
                                "v-flex",
                                { staticClass: "item-description" },
                                [_vm._v(_vm._s(_vm.item.asian_fitting))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.Colore")) + ":"
                                  ),
                                ]),
                              ]),
                              _vm.item.finitura == "OPACO"
                                ? _c(
                                    "v-flex",
                                    { staticClass: "item-description" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.item.colore) +
                                          " - " +
                                          _vm._s(
                                            _vm
                                              .$t("message.opaco")
                                              .toUpperCase()
                                          )
                                      ),
                                    ]
                                  )
                                : _vm.item.finitura == "LUCIDO"
                                ? _c(
                                    "v-flex",
                                    { staticClass: "item-description" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.item.colore) +
                                          " - " +
                                          _vm._s(
                                            _vm
                                              .$t("message.lucido")
                                              .toUpperCase()
                                          )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "v-flex",
                                    { staticClass: "item-description" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.item.colore) +
                                          " - " +
                                          _vm._s(
                                            _vm
                                              .$t("message.Naturale")
                                              .toUpperCase()
                                          )
                                      ),
                                    ]
                                  ),
                              _vm.frontColorWarning
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "svg",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          width: "27",
                                                          height: "27",
                                                          fill: "red",
                                                          viewBox: "0 0 24 24",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      "svg",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "m22.454 20.992-9.87-18.334a.375.375 0 0 0-.661 0L2.051 20.993a.375.375 0 0 0 .33.552h19.745a.374.374 0 0 0 .328-.553Zm-9.264-1.7h-1.874v-1.876h1.874v1.875Zm-.187-2.997h-1.5l-.281-7.5h2.062l-.281 7.5Z",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        906505234
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.frontColorWarning)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.Calibro")) + ":"
                                  ),
                                ]),
                              ]),
                              _vm.item.calibro
                                ? _c("v-flex", { attrs: { xs6: "" } }, [
                                    _vm._v(
                                      _vm._s(_vm.item.calibro) +
                                        "/" +
                                        _vm._s(_vm.item.naso)
                                    ),
                                  ])
                                : _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-icon", [_vm._v("remove")]),
                                      _c("v-icon", [_vm._v("remove")]),
                                      _c("v-icon", [_vm._v("remove")]),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.$t("message.Aste")) + ":"),
                                ]),
                              ]),
                              _vm.item.aste
                                ? _c(
                                    "v-flex",
                                    { staticClass: "item-description" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.aste) +
                                            " " +
                                            _vm._s(_vm.item.finitura_aste ?? "")
                                        ),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "v-flex",
                                    [
                                      _c("v-icon", [_vm._v("remove")]),
                                      _c("v-icon", [_vm._v("remove")]),
                                      _c("v-icon", [_vm._v("remove")]),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.item.lenti_sole && _vm.item.lenti_sole.item_code
                        ? _c("v-divider")
                        : _vm._e(),
                      _vm.item.lenti_sole && _vm.item.lenti_sole.item_code
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "d-flex align-center",
                                  attrs: { wrap: "" },
                                },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.Lenti")) + ":"
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "v-flex",
                                    { staticClass: "item-description" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.lenti_sole.descr)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.$t("message.Nome")) + ":"),
                                ]),
                                _vm.item.nome && _vm.showPrice
                                  ? _c("small", [
                                      _vm._v(
                                        "(+10" +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.user.currency
                                            )
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c(
                                "v-flex",
                                { staticClass: "item-description" },
                                [
                                  _vm.item.nome
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.nome) +
                                            " (" +
                                            _vm._s(_vm.item.colore_nome) +
                                            ")"
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        { staticClass: "text-left" },
                                        [
                                          _c("v-icon", [_vm._v("remove")]),
                                          _c("v-icon", [_vm._v("remove")]),
                                          _c("v-icon", [_vm._v("remove")]),
                                        ],
                                        1
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [_vm._v("Nome Asta Sx:")]),
                                _vm.item.nomeExtAstaSx && _vm.showPrice
                                  ? _c("small", [
                                      _vm._v(
                                        "(+10" +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.user.currency
                                            )
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c(
                                "v-flex",
                                { staticClass: "item-description" },
                                [
                                  _vm.item.nomeExtAstaSx
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.nomeExtAstaSx) +
                                            " (" +
                                            _vm._s(
                                              _vm.item.coloreNomeExtAstaSx
                                            ) +
                                            ")"
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        { staticClass: "text-left" },
                                        [
                                          _c("v-icon", [_vm._v("remove")]),
                                          _c("v-icon", [_vm._v("remove")]),
                                          _c("v-icon", [_vm._v("remove")]),
                                        ],
                                        1
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [_vm._v("Nome Asta Dx:")]),
                                _vm.item.nomeExtAstaDx && _vm.showPrice
                                  ? _c("small", [
                                      _vm._v(
                                        "(+10" +
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.user.currency
                                            )
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c(
                                "v-flex",
                                { staticClass: "item-description" },
                                [
                                  _vm.item.nomeExtAstaDx
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.nomeExtAstaDx) +
                                            " (" +
                                            _vm._s(
                                              _vm.item.coloreNomeExtAstaDx
                                            ) +
                                            ")"
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        { staticClass: "text-left" },
                                        [
                                          _c("v-icon", [_vm._v("remove")]),
                                          _c("v-icon", [_vm._v("remove")]),
                                          _c("v-icon", [_vm._v("remove")]),
                                        ],
                                        1
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs4: "" } }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.$t("message.Note")) + ":"),
                                ]),
                              ]),
                              _vm.item.note
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "item-description",
                                      attrs: { xs8: "" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.item.note)),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "v-flex",
                                    {
                                      staticClass: "item-description",
                                      attrs: { xs8: "" },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("remove")]),
                                      _c("v-icon", [_vm._v("remove")]),
                                      _c("v-icon", [_vm._v("remove")]),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.showPrice ? _c("v-divider") : _vm._e(),
                      _vm.showPrice
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-left",
                                      attrs: { xs4: "" },
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.Prezzo")) + ":"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "item-description text-left",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.item.price) +
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm.user.currency
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: "500" },
          model: {
            value: _vm.lentiSoleDialog,
            callback: function ($$v) {
              _vm.lentiSoleDialog = $$v
            },
            expression: "lentiSoleDialog",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "login-window",
              attrs: { shaped: "", elevation: "5" },
            },
            [
              _c(
                "v-card-title",
                { staticClass: "align-center bg-primary" },
                [
                  _c("v-flex", { attrs: { "d-flex": "", "flex-column": "" } }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "ml-3 my-0 mr-0 p-0 text-subtitle-1 text-md-h6",
                      },
                      [_vm._v(_vm._s(_vm.$t("message.Lente_sole")))]
                    ),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { top: "5px", right: "5px" },
                      attrs: { absolute: "", icon: "", color: "white" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.lentiSoleDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-2" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", "justify-center": "" } },
                    [
                      _c(
                        "v-list",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.Tipologia_di_lente")
                                            .toUpperCase()
                                        ) + ":"
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "v-flex",
                                    { staticClass: "item-description" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.item.lenti_sole
                                            ? _vm.item.lenti_sole.descr
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }